export default [
  {
    path: '/', redirect: { name: 'admin-applicants' }
  },
  {
    path: '/admin-applicants',
    name: 'admin-applicants',
    meta: { is_paginatable: true },
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/applicants/Applicants.vue'
        )
  },
  {
    path: '/',
    name: 'login',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/Login.vue'
        )
  },
  {
    path: '/recruiters',
    name: 'recruiters',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/views/Recruiters.vue'
        )
  },
  {
    path: '/admin/feed-designators',
    name: 'admin-feed-designators',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/feed_designators/FeedDesignators.vue'
        )
  },
  {
    path: '/admin/presence-report',
    name: 'presence-report',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/presence_report/PresenceReport.vue'
        )
  },
  {
    path: '/admin/efforts',
    name: 'admin-efforts',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/efforts/Efforts.vue'
        )
  },
  {
    path: '/admin/weekly-calendar',
    name: 'admin-weekly-calendar',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/weekly_calendar/WeeklyCalendar.vue'
        )
  },
  {
    path: '/temp-text',
    name: 'temp-text',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/TempText.vue'
        )
  },
  {
    path: '/admin/outsource',
    name: 'admin-outsource',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/outsource/Outsource.vue'
        )
  },
  {
    path: '/admin/owners-schedule',
    name: 'admin-owners-schedule',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/owners_schedule/OwnersSchedule.vue'
        )
  },
  {
    path: '/admin/screens',
    name: 'admin-screens',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/screens/Screens.vue'
        )
  },
  {
    path: '/admin/questions',
    name: 'admin-questions',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/questions/Questions.vue'
        )
  },
  {
    path: '/admin/question-infos',
    name: 'admin-question-infos',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/question_infos/QuestionInfos.vue'
        )
  },
  {
    path: '/admin/question-options',
    name: 'admin-question-options',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/question_options/QuestionOptions.vue'
        )
  },
  {
    path: '/admin/tasks',
    name: 'admin-tasks',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/tasks/Tasks.vue'
        )
  },
  {
    path: '/admin/companies',
    name: 'admin-companies',
    meta: { is_paginatable: true },
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/companies/Companies.vue'
        )
  },
  {
    path: '/admin/positions',
    name: 'admin-positions',
    meta: { is_paginatable: true },
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/positions/Positions.vue'
        )
  },
  {
    path: '/admin/offers/',
    name: 'admin-offers',
    meta: { is_paginatable: true },
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/offers/Offers.vue'
        )
  },
  {
    path: '/admin/alerts/',
    name: 'admin-alerts',
    meta: { is_paginatable: true },
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/alerts/Alerts.vue'
        )
  },
  {
    path: '/admin/stats/',
    name: 'admin-stats',
    meta: { is_paginatable: true },
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/stats/Stats.vue'
        )
  },
  {
    path: '/admin/meetings/',
    name: 'admin-meetings',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/meetings/Meetings.vue'
        )
  },
  {
    path: '/company-employees',
    name: 'company-employees',
    component: () =>
      import(
        /* webpackChunkName: "company-employees" */ '@/components/companies/employees/CompanyEmployees.vue'
      )
  },
  {
    path: '/select-email-position-applicants/',
    name: 'select-email-position-applicants',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/components/SelectEmailPositionApplicants.vue'
      )
  },
  {
    path: '/related-offers/',
    name: 'related-offers',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/RelatedOffers.vue'
        )
  },
  {
    path: '/quick-access',
    name: 'quick-access',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/QuickAccess.vue'
        )
  },
  {
    path: '/developer-interview-articles/',
    name: 'developer-interview-articles',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/developer_interview_articles/DeveloperInterviewArticles.vue'
        )
  },
  {
    path: '/developer-interview-article-comments/',
    name: 'developer-interview-article-comments',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/developer_interview_article_comments/DeveloperInterviewArticleComments.vue'
        )
  },
  {
    path: '/vetting-recipes/',
    name: 'vetting-recipes',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/components/admin/vetting_recipes/VettingRecipes.vue'
        )
  },
  {
    path: '/alerts/in-progress/',
    name: 'alerts-in-progress',
    component: () =>
        import(
          /* webpackChunkName: "about" */ '@/views/alerts/InProgress.vue'
        )
  },
  {
    path: '/admin/recommendations',
    name: 'admin-recommendations',
    component: () =>
        import(/* webpackChunkName: "recommendations" */ '@/views/admin/Recommendations.vue')
  }
]
